import { render, staticRenderFns } from "./AdminGpxTeam.vue?vue&type=template&id=155715e9&scoped=true"
import script from "./AdminGpxTeam.vue?vue&type=script&lang=js"
export * from "./AdminGpxTeam.vue?vue&type=script&lang=js"
import style0 from "./AdminGpxTeam.vue?vue&type=style&index=0&id=155715e9&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "155715e9",
  null
  
)

export default component.exports